<template>
  <success-page-layout
    :cta-copy="$t('ctaCopy')"
    :cta-target="businessHome"
    store-badges-button-code="body-20210304-success-page-business"
    :promote-app-download="false"
  >
    <template v-slot:content>
      <b-headline type="h1" typography="h2" class="mt-6 m:mt-16 mb-4 m:mb-6" v-html="$t('headline')" />

      <p v-if="billDate" class="text-deep-black mb-0">
        {{ $t("billDate", { billDate }) }}
      </p>

      <p v-if="usersEmail" class="text-deep-black">
        {{ $t("sentToYourEmail", { usersEmail }) }}
      </p>
      <p v-else class="text-deep-black">
        {{ $t("sentToYourEmailGeneric") }}
      </p>

      <b-headline v-if="maxSeats" type="h2" typography="h3" class="mb-2" v-html="maxSeatsCopy" />

      <p class="text-dark-grey mb-4">
        {{ $t("annualSubscription") }}
      </p>
    </template>

    <template v-slot:image>
      <join-organisation-image />
    </template>
  </success-page-layout>
</template>

<script>
import BHeadline from "@/component-library/b-headline"
import { getSearchParam } from "@/utils/location"
import SuccessPageLayout from "@/pages/success-page/components/success-page-layout"
import JoinOrganisationImage from "@/pages/success-page/components/join-organisation/image"
import globals from "@/utils/globals"
import { mapGetters } from "vuex"

export default {
  name: "TeamPurchaseSuccess",
  components: {
    JoinOrganisationImage,
    BHeadline,
    SuccessPageLayout
  },
  computed: {
    ...mapGetters(["usersEmail"]),
    ...mapGetters("teamsSettings", ["maxSeats"]),
    businessHome() {
      return globals.routes.businessHome
    },
    billDate() {
      return getSearchParam("billDate")
    },
    maxSeatsCopy() {
      return `Blinkist Team - ${this.maxSeats} seats`
    }
  },
  mounted() {
    this.$store.dispatch("teamsSettings/loadTeam")
  },
  i18n: {
    messages: {
      en: {
        ctaCopy: "Go to Admin Home",
        headline: "You’ve successfully upgraded to the Team plan",
        sentToYourEmail: `We’ve sent the invoice to {usersEmail}.`,
        sentToYourEmailGeneric: "We’ve sent the invoice to your email.",
        annualSubscription: "Annual subscription, renews automatically.",
        billDate: "Your card will be charged on {billDate}."
      },
      de: {
        ctaCopy: "Zum Partner-Portal",
        headline: "Dein Team ist jetzt bereit.<br>Glückwunsch!",
        sentToYourEmail: "Wir haben dir die Rechnung an {usersEmail} geschickt.",
        sentToYourEmailGeneric: "Wir haben dir die Rechnung per E-Mail geschickt.",
        annualSubscription: "Jahresabonnement, wird automatisch verlängert.",
        billDate: "Deine Karte wird am {billDate} belastet."
      },
      es: {
        ctaCopy: "Ir a Inicio Admin",
        headline: "Has actualizado correctamente al plan Team",
        sentToYourEmail: "Hemos enviado la factura a {usersEmail}.",
        sentToYourEmailGeneric: "Hemos enviado la factura a tu correo electrónico.",
        annualSubscription: "Suscripción anual, se renueva automáticamente.",
        billDate: "Tu tarjeta será cargada el {billDate}."
      }
    }
  }
}
</script>
